module.exports = __webpack_public_path__ + "static/media/sell-attribute-group.76af85f4.jpg";